import { setModelsSingleton } from "@doitintl/models-any";
import { getApp } from "firebase/app";
import { getAuth, type IdTokenResult } from "firebase/auth";
// eslint-disable-next-line no-restricted-imports
import { type Firestore, type FirestoreSettings, initializeFirestore } from "firebase/firestore";

import { customAuthApp } from "./initFirebase";

let firestore: Firestore;

export const slimInitMongo = () => {
  setModelsSingleton("default");
};

export const slimInitFirestore = ({
  settings,
  idToken,
}: { settings?: FirestoreSettings & { useFetchStreams?: false }; idToken?: IdTokenResult } = {}): Firestore => {
  if (firestore) {
    return firestore; // single time init
  }

  const enforcedLongPollingCustomersIds = ["ntYC2YHl6abEcZse51E2", "0C86ZKxe6mthbTmCbQgV", "orQOv5NZI37QP3fbqDpg"];
  let actualSettings: FirestoreSettings = { ...(settings ?? {}) };
  if (idToken?.claims?.customerId && enforcedLongPollingCustomersIds.includes(idToken.claims.customerId as string)) {
    actualSettings = {
      ...actualSettings,
      experimentalForceLongPolling: true,
      experimentalAutoDetectLongPolling: false,
    };
  }

  if (customAuthApp && !getAuth()?.currentUser) {
    firestore = initializeFirestore(customAuthApp, actualSettings);
  } else {
    firestore = initializeFirestore(getApp(), actualSettings);
  }

  let params = {};
  if (process.env.NODE_ENV === "development") {
    const listenErrorCallback = (path: string, err: Error, marker: Error) => {
      // eslint-disable-next-line no-console
      console.warn("Firestore error at", path, err, marker.stack);
    };

    params = {
      listenErrorCallback,
    };
  }

  setModelsSingleton(firestore, params);

  return firestore;
};
